import { render, staticRenderFns } from "./PlayerSopMain.vue?vue&type=template&id=b33e6bd6&scoped=true&"
import script from "./PlayerSopMain.vue?vue&type=script&lang=js&"
export * from "./PlayerSopMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSopMain.vue?vue&type=style&index=0&id=b33e6bd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e6bd6",
  null
  
)

export default component.exports